import axios from 'axios';

import { useGlobalStore } from '../../stores/useGlobalStore';

const axiosInstance = axios.create({ baseURL: process.env.BASE_URL });
const authenticatedAxiosInstance = axios.create({ baseURL: process.env.BASE_URL });

authenticatedAxiosInstance.interceptors.request.use((config) => {
  const { accessToken, isStaging, demoSession } = useGlobalStore.getState();
  // Send the demo session cookie only for demo users; off for everyone else.
  config.withCredentials = !!demoSession;
  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
    if (isStaging) {
      config.headers['projectWorkflowState'] = 'staging';
      config.headers['compassmoduleworkflowstate'] = 'staging';
    } else {
      delete config.headers['compassmoduleworkflowstate'];
      delete config.headers['projectWorkflowState'];
    }
  }
  return config;
});

authenticatedAxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config } = error;
    if (error.response?.status === 401 && !config._retry) {
      config._retry = true;
      return authenticatedAxiosInstance(config);
    }
    return Promise.reject(error);
  }
);

export const makeGetRequest = axiosInstance.get;
export const makePostRequest = axiosInstance.post;

export const makeAuthenticatedGetRequest = authenticatedAxiosInstance.get;
export const makeAuthenticatedPostRequest = authenticatedAxiosInstance.post;
export const makeAuthenticatedPutRequest = authenticatedAxiosInstance.put;
